import React from 'react'

export default function Currency({ value, currency = "تومان" }) {
    value = value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (value || value === 0) ? <>{value}&nbsp;{currency}</> : null
}